import React, { useContext } from 'react';
import { Table, ApplicationUIContext } from '@yuhuinc/ui-library';
import { Divider, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import TitleWithIcon from '../common/TitleWithIcon';
import styled from 'styled-components';
import ApplicantStatus from 'components/landlord_app/application_management/common/ApplicantStatus';
import { getTranslatedString } from 'helpers/i18n';

const { Text } = Typography;

const StyledText = styled(Text)`
  display: block;
  margin-bottom: 10px;
`;

const APPLICANT_PEOPLE_COLUMNS = [
  {
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
  },
  {
    title: 'Role',
    dataIndex: 'applicant_type',
    key: 'applicant_type',
    render(value) {
      return getTranslatedString(
        `landlordPortal.applicationManagement.applicationOverview.overview.applicants.applicantTypes.${value}`
      );
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render(value, row) {
      if (!value) return '';
      return <ApplicantStatus applicant={row} />;
    },
  },
];

const ApplicationPeople = ({ application }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const people = [
    ...application.additional_occupants.map((occupant) => ({
      ...occupant,
      applicant_type: 'Occupant',
    })),
    ...application.cotenants.map((cotenant) => ({
      ...cotenant,
      status: cotenant.lifecycle?.substatus,
    })),
  ];

  if (!people.length) return null;

  return (
    <>
      <Divider />
      <TitleWithIcon icon={<TeamOutlined />} text="People" />

      <StyledText>Track the progress of co-applicants, guarantors, and references here.</StyledText>

      <Table
        dataSource={people}
        rowKey="id"
        columns={APPLICANT_PEOPLE_COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={{ hideOnSinglePage: true }}
      />
    </>
  );
};

export default ApplicationPeople;
